module.exports = __webpack_public_path__ + "media/images/icons/SVG/016-93f0372a64bcf03d916cc3c550916486.svg";